"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataIdFromObject = exports.possibleIdFieldsForTypename = void 0;
exports.sha256 = sha256;
var client_1 = require("@apollo/client");
var app_utils_1 = require("@sixfold/app-utils");
var hash_js_1 = __importDefault(require("hash.js"));
var PROFILE_SUFFIX = 'Profile';
var possibleIdFieldsForTypename = function (typename) {
    var snakeCaseTypename = (0, app_utils_1.underscore)(typename);
    var camelCaseTypename = (0, app_utils_1.pascalToCamelCase)(typename);
    var strippedTypename = typename.length > PROFILE_SUFFIX.length &&
        typename.indexOf(PROFILE_SUFFIX) === typename.length - PROFILE_SUFFIX.length
        ? typename.substring(0, typename.length - PROFILE_SUFFIX.length)
        : undefined;
    if (strippedTypename === undefined) {
        return ["".concat(snakeCaseTypename, "_id"), "".concat(camelCaseTypename, "Id")];
    }
    var strippedSnakeCaseTypename = (0, app_utils_1.underscore)(strippedTypename);
    var strippedCamelCaseTypename = (0, app_utils_1.pascalToCamelCase)(strippedTypename);
    return [
        "".concat(snakeCaseTypename, "_id"),
        "".concat(camelCaseTypename, "Id"),
        "".concat(strippedSnakeCaseTypename, "_id"),
        "".concat(strippedCamelCaseTypename, "Id"),
    ];
};
exports.possibleIdFieldsForTypename = possibleIdFieldsForTypename;
var dataIdFromObject = function (object, context) {
    var defaultId = (0, client_1.defaultDataIdFromObject)(object, context);
    if (defaultId !== undefined) {
        return defaultId;
    }
    // eslint-disable-next-line no-underscore-dangle
    var typename = object.__typename;
    if (typename !== undefined) {
        var fieldsToCheck = (0, exports.possibleIdFieldsForTypename)(typename);
        var idField = fieldsToCheck.find(function (field) { return object[field] !== undefined; });
        if (idField !== undefined) {
            return "".concat(typename, ":").concat(object[idField]);
        }
    }
    // We don't really know what to use as an ID
    return undefined;
};
exports.dataIdFromObject = dataIdFromObject;
/**
 * Simple wrapper to provide a hashing algorithm needed for persisted queries
 */
function sha256() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var hash = hash_js_1.default.sha256();
    args.forEach(function (arg) { return hash.update(arg); });
    return hash.digest('hex');
}
//# sourceMappingURL=utils.js.map